import { create } from 'zustand';
import { apiService } from '@/services/api.service';

/** Compteur global de demandes en attente + indicateur de traitement (badge/spinner de navigation). */
interface PendingState {
  count: number;
  processing: boolean;
  setCount: (n: number) => void;
  setProcessing: (b: boolean) => void;
  fetch: (project: string) => Promise<void>;
}

export const usePendingRequestsStore = create<PendingState>((set) => ({
  count: 0,
  processing: false,
  setCount: (n) => set({ count: n }),
  setProcessing: (b) => set({ processing: b }),
  fetch: async (project) => {
    if (!project) return;
    try {
      const r = await apiService.listDeployRequests(project);
      set({ count: (r.data?.requests ?? []).filter((x) => x.status === 'pending').length });
    } catch {
      /* silencieux */
    }
  },
}));
